import Vue from "vue";

/**
 * Prevent button reclick directive
 * Usage: v-prevent-reclick="3000" (time in milliseconds)
 */
Vue.directive("prevent-reclick", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 2000);
      }
    });
  }
});
